<template>
    <div>
        <v-data-table 
            v-model="dMatMatriculaTable.selected"
            :headers="dMatMatriculaTable.headers" 
            :items="dMatMatriculas"
            :item-class="fuItemRowClass"
            :loading="dMatMatriculaTable.loading" 
            :search="dMatMatriculaTable.search"
            :items-per-page="-1"
            class="elevation-1" hide-default-footer dense
        >
            <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning" outlined border="top">No hay registros para mostrar.</v-alert></template>
            <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning" outlined border="top">No se encontro ningun registro con su busqueda "{{ dMatMatriculaTable.search }}".</v-alert></template>
            <template v-if="dMatSeccion" v-slot:top>
                <v-card min-width="600" color="#385F73" dark>
                    <v-row align="center">
                        <v-col cols="1" sm="1" md="1" lg="1" align="center">
                            <v-icon x-large :color="dMatSeccion.nMatriculaCerrada===1 ? 'red':''" :title="dMatSeccion.nMatriculaCerrada===1 ? 'Matricula Cerrada':'Matricula Abierta'">{{ fuTurnoIcono(dMatSeccion.Turno) }}</v-icon>
                        </v-col>
                        <v-col cols="4" sm="4" md="4" lg="4">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title :title="dMatSeccion.IdSeccion" :class="[dMatSeccion.Concluyo=='1' ? 'red--text':'']">
                                        <span class="display-1">{{ dMatSeccion.matperiodo.Nivel+dMatSeccion.Seccion }}</span> {{ dMatSeccion.matperiodo.Anio+'-'+dMatSeccion.matperiodo.Periodo }}
                                        <v-chip v-if="dMatSeccion.especial" color="deep-purple accent-4" small><v-icon small left>star</v-icon>Especial</v-chip>
                                    </v-list-item-title>
                                    <v-list-item-subtitle><h5>{{ dMatSeccion.matperiodo.priservicio.Iniciales }}</h5></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                        <v-col cols="5" sm="5" md="5" lg="5">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-subtitle>F. Inicio: {{ dMatSeccion.FechaInicio.substring(0,10) }}</v-list-item-subtitle>
                                    <v-list-item-subtitle>F. Fin: {{ dMatSeccion.FechaFin.substring(0,10) }}</v-list-item-subtitle>
                                    <v-text-field
                                        v-model="dMatMatriculaTable.search"
                                        prepend-icon="filter_alt"
                                        label=""
                                        clearable
                                        single-line
                                        dense
                                        hide-details
                                    ></v-text-field>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                        <v-col cols="2" sm="2" md="2" lg="2" align="left">
                            <v-menu bottom offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                </template>
                                <v-list>
                                    <v-list-item style="min-height: 35px">
                                        <v-list-item-title>
                                            <v-btn @click="fuCursoActualizar(dMatSeccion.IdSeccion)" block small><v-icon>refresh</v-icon> Actualizar Curso</v-btn>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-title>
                                            <v-btn @click="fuMatriculaAperturarCerrar(dMatSeccion.IdSeccion, dMatSeccion.nMatriculaCerrada)" :color="dMatSeccion.nMatriculaCerrada===1 ? 'primary':'error'" block>
                                                <v-icon>{{ dMatSeccion.nMatriculaCerrada===1 ? 'key':'lock' }}</v-icon> 
                                                {{ dMatSeccion.nMatriculaCerrada===1 ? 'Aperturar Matricula':'Cerrar Matricula' }}
                                            </v-btn>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-title>
                                            <v-btn @click="fuSeccionActivarCerrar(dMatSeccion.IdSeccion, dMatSeccion.Concluyo)" :color="dMatSeccion.Concluyo=='1' ? 'primary':'error'" block>
                                                <v-icon>{{ dMatSeccion.Concluyo=='1' ? 'key':'lock' }}</v-icon> 
                                                {{ dMatSeccion.Concluyo=='1' ? 'Activar Sección':'Cerrar Sección' }}
                                            </v-btn>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-title>
                                            <v-btn @click="fuEspecialActivarDesactivar(dMatSeccion.IdSeccion, dMatSeccion.especial)" :color="dMatSeccion.especial=='1' ? 'purple lighten-3':'purple'" block dark>
                                                <v-icon>{{ dMatSeccion.especial=='1' ? 'star_border':'star' }}</v-icon> 
                                                {{ dMatSeccion.especial=='1' ? 'Desactivar Especial':'Activar Especial' }}
                                            </v-btn>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-card>
            </template>
            <template v-slot:[`item.Nro`]="{ item }">
                <span>{{item.Nro}}</span>
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" x-small><v-icon>more_vert</v-icon></v-btn>
                    </template>
                    <v-list>
                        <!-- <v-list-item v-if="!cSeccionFinShow && !item.Matriculado" style="min-height: 35px"> -->
                        <v-list-item v-if="!item.Matriculado" style="min-height: 35px">
                            <v-list-item-title><v-btn @click="fuRetirarCheck(item.IdMatricula)" color="error" block small><v-icon>remove_circle</v-icon> Retirar Matricula</v-btn></v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="!cSeccionFinShow && ['REGULAR','REINICIO','REPITENCIA'].includes(item.CondicionMat)" style="min-height: 35px">
                            <v-list-item-title><v-btn @click="fuCambioSeccion(item)" color="warning" block small><v-icon>sync_alt</v-icon> Cambiar Sección</v-btn></v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="!cSeccionFinShow && !['DIRIGIDO','POR CURSO'].includes(item.CondicionMat)" style="min-height: 35px">
                            <v-list-item-title>
                                <v-btn @click="fuCambioCondicionMat(item)" block small><v-icon>sell</v-icon> Cambiar Condición</v-btn>
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item style="min-height: 35px">
                            <v-list-item-title>
                                <v-btn @click="fuHabilitarRetirarMatricular(item.IdMatricula)" block small><v-icon>remove_circle_outline</v-icon> Habilitar Retirar Matricula</v-btn>
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="['DIRIGIDO'].includes(item.CondicionMat)" style="min-height: 35px">
                            <v-list-item-title>
                                <v-btn @click="fuIngresarNotaCursoDirigido(item)" block small><v-icon>tag</v-icon> Ingreso de Nota Curso Dirigido</v-btn>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
            <template v-slot:[`item.prialumno.Alumno`]="{ item }">
                <v-btn @click="fuIdAlumnoChange(item.prialumno.IdAlumno)" :title="item.prialumno.IdAlumno" color="success" class="pa-0" text small>{{item.prialumno.Alumno}}</v-btn>
                <v-icon v-if="!item.Matriculado" title="Ningún pago" color="error">monetization_on</v-icon>
            </template>
            <template v-slot:[`item.FechaMatricula`]="{ item }">
                <span :title="item.IdMatricula">{{ item.FechaMatricula.substring(2,16) }}</span>
            </template>
            <template v-slot:[`item.CondicionMat`]="{ item }">
                {{ item.CondicionMat }}
            </template>
        </v-data-table>
        <v-dialog v-model="dModalMatricular.dialog" max-width="500">
            <v-card>
                <v-form ref="refMain">
                    <v-card-title class="warning">
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!dIdSeccion?true:false || dJustificacion==''?true:false" @click="fuCambioSeccionSave" :loading="dModalMatricular.loading" color="warning"><v-icon>sync_alt</v-icon> Cambio Sección</v-btn>
                        <v-btn @click="dModalMatricular.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text class="pa-2">
                        <v-autocomplete
                            v-model="dIdSeccion"
                            :items="dMatSecciones"
                            filled
                            chips
                            color="blue-grey lighten-2"
                            label="* Nueva Sección"
                            item-text="name"
                            item-value="id"
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    @click="data.select">
                                    <v-avatar>
                                        <v-icon>{{ fuTurnoIcono(data.item.avatar) }}</v-icon>
                                    </v-avatar>
                                    <strong>{{ " " + data.item.name }}</strong> 
                                    <span> {{ " " + data.item.group + " " + fuMesNombre(parseInt(data.item.FechaInicio.substring(5,7)))+" "+parseInt(data.item.FechaInicio.substring(8,10))}}</span>
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template>
                                    <v-list-item-avatar>
                                        <v-icon large>{{ fuTurnoIcono(data.item.avatar) }}</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <strong>{{ data.item.name }}</strong> {{ data.item.group }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>{{fuMesNombre(parseInt(data.item.FechaInicio.substring(5,7)))+" "+parseInt(data.item.FechaInicio.substring(8,10))}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </template>
                        </v-autocomplete>
                        <v-textarea
                            v-model="dJustificacion"
                            prepend-inner-icon="message"
                            label="* Justificación"
                            outlined
                            :maxlength="50"
                            rows="2"
                            row-height="15" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 50) || 'El campo debe ser menor de 50 caracteres.']"
                        ></v-textarea>
                    </v-card-text>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dModalCambioCondicionMat.dialog" max-width="400">
            <v-card>
                <v-card-title class="text-h5 blue-grey">
                        <v-spacer></v-spacer>
                        <v-btn :disabled="dCondicionMat?false:true" @click="fuCambioCondicionMatSave" :loading="dModalCambioCondicionMat.loading" color="default"><v-icon>save</v-icon> Cambiar Condición</v-btn>
                        <v-btn @click="dModalCambioCondicionMat.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pa-2">
                    <v-select v-model="dCondicionMat" label="* Condición" :items="dCondicionMats" filled prepend-inner-icon="sell" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dModalCursoActualizar.dialog" max-width="600">
            <v-card>
                <v-card-title class="text-h5 blue-grey">
                        <v-spacer></v-spacer>
                        <v-btn :disabled="dIdCursoCurricula?false:true" @click="fuCursoActualizarSave" :loading="dModalCursoActualizar.loading" color="default"><v-icon>save</v-icon> Actualizar Curso</v-btn>
                        <v-btn @click="dModalCursoActualizar.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pa-2">
                    <v-select 
                        v-model="dIdCursoCurricula" 
                        label="* Curso" 
                        :items="dMatCursosCurriculas" 
                        item-value="IdCursoCurricula" item-text="Descripcion"
                        filled prepend-inner-icon="sell" :rules="[v => !!v || 'El campo es requerido']"
                        :title="dIdCursoCurricula"
                    ></v-select>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-navigation-drawer
            v-model="dModalIngresarNotaCursoDirigido.dialog"
            right
            temporary
            fixed
            width="400"
        >
            <v-list-item class="text-h5 blue-grey" dark>
                <v-list-item-content>
                    <v-list-item-title class="text-h6">Ingreso de Nota Curso Dirigido</v-list-item-title>
                </v-list-item-content>                
                <v-btn icon @click="dModalIngresarNotaCursoDirigido.dialog = false"><v-icon>close</v-icon></v-btn>
            </v-list-item>

            <v-divider></v-divider>

            <div class="pa-2">
                <v-row v-for="item in dDcbNotaCursoDirigido" :key="item.ID">
                    <v-col cols="12" sm="7">
                        <span>{{item.matcursoscurricula.matcurso.Descripcion}}</span>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-text-field
                            label="Nota"
                            v-model.number="item.Nota" 
                            type="number"
                            outlined
                            :rules="[
                                v => !!v || 'El campo es requerido',
                                v => (v >= 0 && v <= 20) || 'La nota debe estar entre 0 y 20'
                            ]"
                            min="0" max="20"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-btn icon @click="fudcbnotacursodirigidoUpdate(item)"><v-icon>save</v-icon></v-btn>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
            </div>
        </v-navigation-drawer>
    </div>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {fuTurnoIcono, fuMesNombre} from '@/helpers/index.js';

export default {
    name: 'MatSeccionMatriculaList',
    props: {
        pIdSeccion: {
            type: Number,
            required: true,
        }
    },
    data: () => ({
        dIdSeccion: null,
        dIdCursoCurricula: null,
        dCondicionMat: null,
        dCondicionMats: [],
        dDcbNotaCursoDirigido: [],
        dMatCursosCurriculas: [],
        dJustificacion: "",
        dMatMatricula: null,
        dMatMatriculas: [],
        dMatMatriculaTable: {
            headers: [
                {value: 'IdMatricula', text: 'IdMatricula', align: ' d-none'},
                {value: 'Nro', text: 'Nro'},
                {value: 'prialumno.Alumno', text: 'Alumno'},                
                {value: 'prialumno.Codigo', text: 'Codigo'},
                {value: 'FechaMatricula', text: 'F. Matricula'},                
                {value: 'CondicionMat', text: '...'},
                {value: 'Operador', text: 'Usuario'},
            ],
            loading: false,
            search: null,
            selected: [],
        },
        dMatSeccion: null,
        dMatSecciones: [],
        dModalMatricular: {
            dialog: false,
            loading: false,
        },
        dModalCambioCondicionMat: {
            dialog: false,
            loading: false,
        },
        dModalCursoActualizar: {
            dialog: false,
            loading: false,
        },
        dModalIngresarNotaCursoDirigido: {
            dialog: false,
            loading: false,
        },
    }),
    watch: {
        pIdSeccion(val){
            if(val)
                this.fumatmatriculaByIdSeccion(val);
        },
    },
    computed: {
        ...mapState(['ssUser', 'ssPriServiciosIngreso']),
        cSeccionFinShow: function () {
            let hoy = moment().format("YYYYMMDD");
            let FechaFin = moment(this.dMatSeccion.FechaFin).subtract(1, 'months').format("YYYYMMDD");

            if(FechaFin<hoy)
                return true;
            else
                return false;
        },
    },
    methods: {
        fuTurnoIcono, fuMesNombre,
        fuIdAlumnoChange(p_IdAlumno){
            this.$emit('fuIdAlumnoChange', p_IdAlumno);
        },
        fuItemRowClass(item){
            if (item.IdMatricula === this.dMatMatricula.IdMatricula) {
                return 'resaltar-fila';
            }
            return '';
        },
        async fumatmatriculaByIdSeccion(vIdSeccion){            
            this.dIdCursoCurricula= null;
            this.dMatCursosCurriculas = [];
            this.dMatMatriculas = [];
            this.dMatMatriculaTable.loading = true;
            this.dMatMatriculaTable.selected = [];
            this.dMatMatriculaTable.search = '';
            try {
                const response = await this.$apollo.query({
                    query: gql`query matmatriculaByIdSeccionByActivo($IdSeccion: Int!, $IdSeccion2: ID!, $Activo: Boolean!){
                        matmatriculaByIdSeccionByActivo(IdSeccion:$IdSeccion, Activo:$Activo){
                            IdMatricula
                            FechaMatricula
                            Matriculado
                            CondicionMat
                            Operador
                            prialumno{
                                IdAlumno
                                Alumno
                                Codigo
                                IdModalidadAdmision
                            }
                        }
                        matseccion(IdSeccion:$IdSeccion2){
                            IdSeccion
                            Seccion
                            Turno
                            FechaInicio
                            FechaFin
                            Concluyo
                            nMatriculaCerrada
                            especial
                            matperiodo{
                                Anio
                                Periodo
                                Nivel
                                IdServicio
                                priservicio{
                                    Iniciales
                                }
                            }
                            matcursoscurricula{
                                IdCursoCurricula
                                matcurso{
                                    Descripcion
                                }
                            }
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        IdSeccion: vIdSeccion,
                        IdSeccion2: vIdSeccion,
                        Activo: true,
                    }
                });
                this.dMatSeccion = response.data.matseccion;
                this.dMatCursosCurriculas = response.data.matseccion.matcursoscurricula
                    .map(obj => ({
                        IdCursoCurricula: obj.IdCursoCurricula,
                        Descripcion: obj.IdCursoCurricula + " - " + obj.matcurso.Descripcion,
                    }));
                
                let vMatMatriculas = response.data.matmatriculaByIdSeccionByActivo;
                vMatMatriculas = vMatMatriculas.sort((p1, p2) => (p1.prialumno.Alumno < p2.prialumno.Alumno) ? -1 : (p1.prialumno.Alumno > p2.prialumno.Alumno) ? 1 : 0);
                let count=1;
                vMatMatriculas.forEach( function(item){
                    item.Nro = count++;
                })
                this.dMatMatriculas = vMatMatriculas;
            } catch (error) {
                Swal.fire('¡ ERROR !', 'Error de conexión....', 'error');
                console.log(error);
            } finally {
                this.dMatMatriculaTable.loading = false
            }
        },
        fuRetirarCheck(vIdMatricula){
            Swal.fire({
                icon: 'question',
                title: '¿Estás seguro?',
                html: '<h3>Se eliminará la matricula y las notas del alumno.</h3>',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    this.fuRetirar(vIdMatricula);
                },
            }).then(() => {
            })
        },
        async fuRetirar(vIdMatricula){
            try {
                this.dMatMatriculaTable.loading = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation matmatriculaRetirar($IdMatricula: Int!, $IdSeccion: Int!){
                        matmatriculaRetirar(IdMatricula: $IdMatricula, IdSeccion: $IdSeccion){
                            error
                            message
                        }
                    }`,
                    variables: {
                        IdMatricula: vIdMatricula,
                        IdSeccion: this.dMatSeccion.IdSeccion,
                    }
                });
                if(response.data.matmatriculaRetirar.error==0){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: response.data.matmatriculaRetirar.message});
                    this.fumatmatriculaByIdSeccion(this.dMatSeccion.IdSeccion);
                    this.$emit('fuMatriculaList');
                } else {
                    Swal.fire({ icon: 'warning', title: '¡ ADVERTENCIA !', html: response.data.matmatriculaRetirar.message})
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
                this.dMatMatriculaTable.loading = false;
            }
        },
        fuCambioSeccion(item){
            this.dModalMatricular.dialog = true;
            this.dMatMatricula = item;
            this.dIdSeccion = null;
            this.dJustificacion = "";
            this.fumatseccionAMatricular(item.prialumno.IdAlumno);
        },
        fuCambioCondicionMat(item){
            this.dMatMatricula = item;
            this.dCondicionMat = null;
            this.dCondicionMats =[];
            this.dModalCambioCondicionMat.dialog = true;
            const vCondicionMat = ['REGULAR','REINICIO','REPITENCIA','TRASLADO EXTERNO'];
            this.dCondicionMats = vCondicionMat.filter(obj => obj !== item.CondicionMat);
        },
        fuCursoActualizar(item){
            this.dModalCursoActualizar.dialog = true;
        },
        async fumatseccionAMatricular(p_IdAlumno){
            try {
                this.dMatSecciones = [];
                const response = await this.$apollo.query({
                    query: gql`
                        query matriculaPrev($IdAlumno: ID!){
                            matseccionAMatricular(IdAlumno: $IdAlumno){
                                IdSeccion
                                Seccion
                                Turno
                                FechaInicio
                                FechaFin
                                matperiodo{
                                    Anio
                                    Periodo
                                    Nivel
                                }
                                ingcronogramapagos{
                                    IdCronograma
                                }
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: p_IdAlumno,
                    }
                })
                this.dMatSecciones = response.data.matseccionAMatricular
                    .filter(obj => obj.IdSeccion != this.dMatSeccion.IdSeccion)
                    .map(obj => ({
                        id: obj.IdSeccion,
                        name: obj.matperiodo.Nivel + obj.Seccion,
                        group: obj.matperiodo.Anio + '-' + obj.matperiodo.Periodo,
                        avatar: obj.Turno,
                        FechaInicio: obj.FechaInicio,
                    }));
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
            }
        },
        async fuCambioSeccionSave(){
            this.$refs.refMain.validate()

            try {
                this.dModalMatricular.loading = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation matmatriculaCambioSeccion($IdMatricula: Int!, $IdSeccion: Int!, $UserName: Int!, $Justificacion: String!){
                        matmatriculaCambioSeccion(IdMatricula: $IdMatricula, IdSeccion: $IdSeccion, UserName: $UserName, Justificacion: $Justificacion){
                            error
                            message
                        }
                    }`,
                    variables: {
                        IdMatricula: this.dMatMatricula.IdMatricula,
                        IdSeccion: this.dIdSeccion,
                        UserName: this.ssUser.IdPersonal,
                        Justificacion: this.dJustificacion,
                    }
                });
                if(response.data.matmatriculaCambioSeccion.error==0){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: response.data.matmatriculaCambioSeccion.message});
                    this.fumatmatriculaByIdSeccion(this.pIdSeccion);
                } else {
                    Swal.fire({ icon: 'warning', title: '¡ ADVERTENCIA !', html: response.data.matmatriculaCambioSeccion.message})
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
                this.dModalMatricular.loading = false;
            }
        },
        async fuCambioCondicionMatSave(){
            try {
                this.dModalCambioCondicionMat.loading = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation matmatriculaUpdate($IdMatricula: ID!, $input: matmatriculaUpdateInput!){
                        matmatriculaUpdate(IdMatricula: $IdMatricula, input: $input){
                            IdMatricula
                        }
                    }`,
                    variables: {
                        IdMatricula: this.dMatMatricula.IdMatricula,
                        input: {
                            CondicionMat: this.dCondicionMat
                        }
                    }
                });
                if(response.data.matmatriculaUpdate){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: 'Registro actualizado'});
                    this.fumatmatriculaByIdSeccion(this.pIdSeccion);
                } else {
                    Swal.fire({ icon: 'warning', title: '¡ ADVERTENCIA !', html: 'Registro incorrecto' })
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
                this.dModalCambioCondicionMat.loading = false;
                this.dModalCambioCondicionMat.dialog = false;
            }
        },
        fuHabilitarRetirarMatricular(vIdMatricula){
            Swal.fire({
                icon: 'question',
                title: '¿Estás seguro?',
                html: '<h3>Se habilita retirar matricula.</h3>',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    this.fuHabilitarRetirarMatricularSave(vIdMatricula);
                },
            }).then(() => {
            })
        },
        async fuHabilitarRetirarMatricularSave(vIdMatricula){
            try {
                this.dMatMatriculaTable.loading = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation matmatriculaUpdate($IdMatricula: ID!, $input: matmatriculaUpdateInput!){
                        matmatriculaUpdate(IdMatricula: $IdMatricula, input: $input){
                            IdMatricula
                        }
                    }`,
                    variables: {
                        IdMatricula: vIdMatricula,
                        input: {
                            Matriculado: false
                        }
                    }
                });
                if(response.data.matmatriculaUpdate){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: 'Registro actualizado'});
                    this.fumatmatriculaByIdSeccion(this.pIdSeccion);
                } else {
                    Swal.fire({ icon: 'warning', title: '¡ ADVERTENCIA !', html: 'Registro incorrecto' })
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
                this.dMatMatriculaTable.loading = false;
            }
        },
        async fuCursoActualizarSave(){
            try {
                this.dModalCursoActualizar.loading = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation dcbnotafinal_actualizar_byIdSeccion_byIdCursoCurricula($IdSeccion: Int!, $IdCursoCurricula: Int!){
                        dcbnotafinal_actualizar_byIdSeccion_byIdCursoCurricula(IdSeccion: $IdSeccion, IdCursoCurricula: $IdCursoCurricula){
                            error
                        }
                    }`,
                    variables: {
                        IdSeccion: this.pIdSeccion,
                        IdCursoCurricula: this.dIdCursoCurricula,
                    }
                });
                if(response.data.dcbnotafinal_actualizar_byIdSeccion_byIdCursoCurricula){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: 'Registro actualizado'});
                } else {
                    Swal.fire({ icon: 'warning', title: '¡ ADVERTENCIA !', html: 'Registro incorrecto' })
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
                this.dModalCursoActualizar.loading = false;
                this.dModalCursoActualizar.dialog = false;
            }
        },
        fuIngresarNotaCursoDirigido(vItem){
            this.dModalIngresarNotaCursoDirigido.dialog = true;
            this.dMatMatricula = vItem;
            this.fudcbnotacursodirigidoByIdMatricula(vItem.IdMatricula);
        },
        async fudcbnotacursodirigidoByIdMatricula(p_IdMatricula){
            try {
                this.dDcbNotaCursoDirigido = [];
                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($IdMatricula: Int!){
                            dcbnotacursodirigidoByIdMatricula(IdMatricula: $IdMatricula){
                                ID
                                Nota
                                matcursoscurricula{
                                    matcurso{
                                        Descripcion
                                    }
                                }
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdMatricula: p_IdMatricula,
                    }
                })
                this.dDcbNotaCursoDirigido = response.data.dcbnotacursodirigidoByIdMatricula;
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
            }
        },
        async fudcbnotacursodirigidoUpdate(vItem){
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation dcbnotacursodirigidoUpdate($ID: ID!, $input: dcbnotacursodirigidoUpdateInput!){
                        dcbnotacursodirigidoUpdate(ID: $ID, input: $input){
                            ID
                        }
                    }`,
                    variables: {
                        ID: vItem.ID,
                        input: {
                            Nota: vItem.Nota
                        },
                    }
                });
                if(response.data.dcbnotacursodirigidoUpdate){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: 'Registro correcto'});
                    this.dModalIngresarNotaCursoDirigido.dialog=false;
                } else {
                    Swal.fire({ icon: 'warning', title: '¡ ADVERTENCIA !', html: 'Registro incorrecto'})
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
            }
        },
        fuMatriculaAperturarCerrar(vIdSeccion, vnMatriculaCerrada){
            Swal.fire({
                icon: 'question',
                title: '¿Estás seguro?',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: (login) => {
                    if (vnMatriculaCerrada==1)
                        this.fuMatriculaAperturarCerrarUpdate(vIdSeccion, 0);
                    else
                        this.fuMatriculaAperturarCerrarUpdate(vIdSeccion, 1);
                },
            }).then((result) => {
            })
        },
        async fuMatriculaAperturarCerrarUpdate(vIdSeccion, vCerrado) {
            try {
                this.dLoading = true;
                var data = null;
                if(vCerrado==0){
                    data = {
                        nMatriculaCerrada: vCerrado
                    }
                } else {
                    data = {
                        nMatriculaCerrada: vCerrado,
                        dFechaCierre: moment().format("YYYYMMDD HH:mm:ss"),
                        cUsuarioCierreMatricula: this.ssUser.Usuario
                    }
                }

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation matseccionUpdate($IdSeccion: ID!, $input: matseccionUpdateInput!){
                        matseccionUpdate(IdSeccion: $IdSeccion, input: $input){
                            IdSeccion
                        }
                    }`,
                    variables: {
                        IdSeccion: vIdSeccion,
                        input: data
                    }
                });

                if(response.data){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: 'Registro correcto'});
                    this.dMatSeccion.nMatriculaCerrada=vCerrado;
                    this.$emit('fuSeccionSearch');
                } else {
                    Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
                this.dLoading = false;
            }
        },
        fuEspecialActivarDesactivar(vIdSeccion, vEspecial){
            Swal.fire({
                icon: 'question',
                title: '¿Estás seguro?',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: (login) => {
                    if (vEspecial=='1')
                        this.fuEspecialActivarDesactivarUpdate(vIdSeccion, 0);
                    else
                        this.fuEspecialActivarDesactivarUpdate(vIdSeccion, 1);
                },
            }).then((result) => {
            })
        },
        async fuEspecialActivarDesactivarUpdate(vIdSeccion, vEspecial) {
            try {
                this.dLoading = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation matseccionUpdate($IdSeccion: ID!, $input: matseccionUpdateInput!){
                        matseccionUpdate(IdSeccion: $IdSeccion, input: $input){
                            IdSeccion
                        }
                    }`,
                    variables: {
                        IdSeccion: vIdSeccion,
                        input: {
                            especial: vEspecial
                        }
                    }
                });

                if(response.data){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: 'Registro correcto'});
                    this.dMatSeccion.especial=vEspecial;
                    this.$emit('fuSeccionSearch');
                } else {
                    Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
                this.dLoading = false;
            }
        },
        fuSeccionActivarCerrar(vIdSeccion, vConcluyo){
            Swal.fire({
                icon: 'question',
                title: '¿Estás seguro?',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: (login) => {
                    if (vConcluyo=='1')
                        this.fuSeccionActivarCerrarUpdate(vIdSeccion, 0);
                    else
                        this.fuSeccionActivarCerrarUpdate(vIdSeccion, 1);
                },
            }).then((result) => {
            })
        },
        async fuSeccionActivarCerrarUpdate(vIdSeccion, vConcluyo) {
            try {
                this.dLoading = true;
                var response = null;

                if(vConcluyo==0) {
                    response = await this.$apollo.mutate({
                        mutation: gql`mutation matseccionUpdate($IdSeccion: ID!, $input: matseccionUpdateInput!){
                            matseccionUpdate(IdSeccion: $IdSeccion, input: $input){
                                IdSeccion
                            }
                        }`,
                        variables: {
                            IdSeccion: vIdSeccion,
                            input: {
                                Concluyo: vConcluyo
                            }
                        }
                    });
                } else {
                    response = await this.$apollo.mutate({
                        mutation: gql`mutation muSeccionCerrar($IdSeccion: ID!, $IdSeccion2: Int!, $Operador: String!, $input: matseccionUpdateInput!){
                            mutation1: dcbhorarioSPHORARIOS(IdSeccion: $IdSeccion2, Accion: "4"){
                                error
                            },
                            mutation2: dcbnotarecuperacionBySeccionInsertUpdate(IdSeccion: $IdSeccion2, Operador: $Operador, Accion: "C"){
                                error
                            },
                            mutation3: matseccionUpdate(IdSeccion: $IdSeccion, input: $input){
                                IdSeccion
                            }
                        }`,
                        variables: {
                            IdSeccion: vIdSeccion,
                            IdSeccion2: vIdSeccion,
                            Operador : this.ssUser.Usuario,
                            input: {
                                Concluyo: vConcluyo
                            },
                        }
                    });
                }
                if(response.data){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: 'Registro correcto'});
                    this.dMatSeccion.Concluyo=vConcluyo;
                    this.$emit('fuSeccionSearch');
                } else {
                    Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
                this.dLoading = false;
            }
        },
    }
}
</script>
<style>
    .resaltar-fila {
        background-color: #FFF9C4 !important; /* Un color amarillo suave */
    }

    .resaltar-fila:hover {
        background-color: #FFF59D !important;
    }
</style>
